import React from "react";
import { connect } from "react-redux";
import arcone from "assets/images/leftarc.svg";
import rightarc from "assets/images/rightarc.svg";
import mobileTopArc from "assets/images/mobile-top-curve.svg";
import woman from "assets/images/woman.png";
import doctor from "assets/images/doctor.jpg";
import {
  Box,
  Grid,
  Card,
  useTheme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SubFooterView from "components/SubFooterView";
import FooterView from "./FooterView";

const SearchMainTemplate = (props) => {
  const {
    children,
    pageTitle,
    minHeightValue,
    viewType,
    showGauge,
    organizationInfo,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matchesSmall = useMediaQuery("(max-width:600px)");
  const matchesMd = useMediaQuery(theme.breakpoints.down("md"));
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";

  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const widgetEnabled = sessionStorage.getItem("widgetEnabled");

  const isPOSTemplate =
    organizationInfo?.type?.toLowerCase() === "p" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  return (
    <Grid container>
      <Grid
        item
        container
        sx={{
          minHeight: "500px",
        }}
      >
        {isShowBackgroundAssets && (
          <>
            <Box sx={{ display: matchesMd ? "block" : "none" }}>
              <img
                src={mobileTopArc}
                alt="mabile-arc"
                className="left-mobile-arc"
                style={{ transform: "rotate(180deg)" }}
              />
            </Box>

            <Box sx={{ display: matchesMd ? "none" : "block" }}>
              <img
                src={arcone}
                alt="top"
                className="search-medication-top-curve"
              />
            </Box>

            <Box sx={{ display: matchesMd ? "none" : "block" }}>
              <img src={rightarc} alt="top" className="right-arc" />
            </Box>
          </>
        )}
        <Grid
          item
          container
          sx={{
            minHeight: minHeightValue,
            display: widgetEnabled?.toLowerCase() === "y" ? "flex" : undefined,
            justifyContent:
              widgetEnabled?.toLowerCase() === "y" ? "center" : undefined,
          }}
        >
          <Grid item xs={12} sm={12} lg={7}>
            <Box
              sx={{
                width: matchesMd ? undefined : "65%",
                display: "flex",
                alignItems: "center",
                margin: "auto",
                marginTop: matchesSmall
                  ? "1px"
                  : viewType !== "insurance"
                  ? "50px"
                  : "40px",
                marginBottom:
                  matchesSmall && viewType !== "insurance" && showGauge
                    ? "50px"
                    : 0,
              }}
            >
              <Typography
                variant={matchesSmall ? "h2LatoBlack" : "h1LatoBlack"}
                sx={{
                  fontSize: matchesMd ? "20px" : undefined,
                  paddingLeft: matchesMd ? "24px" : undefined,
                  display: matchesSmall ? "block" : "none",
                }}
              >
                {pageTitle || ""}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "block",
                width: matches ? "100%" : "90%",
                margin: "auto",
                position: "relative",
              }}
            >
              <Card
                sx={{
                  minHeight:
                    isPOSTemplate ||
                    organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() !==
                      "y"
                      ? 400
                      : 550,
                }}
              >
                {children}
              </Card>
            </Box>
          </Grid>
          {widgetEnabled?.toLowerCase() === "n" && (
            <Grid
              item
              lg={5}
              sx={{
                position: "relative",
                overflow: "hidden",
                justifyContent: isHCPTemplate ? "center" : undefined,
                alignItems: isHCPTemplate ? "center" : undefined,
                display: {
                  xl: isHCPTemplate ? "flex" : "block",
                  lg: isHCPTemplate ? "flex" : "block",
                  md: isHCPTemplate ? "block" : "none",
                  sm: isHCPTemplate ? "block" : "none",
                  xs: isHCPTemplate ? "block" : "none",
                },
              }}
            >
              {isHCPTemplate && (
                <>
                  <Box
                    pt={1}
                    sx={{
                      height: "100%",
                      display: matches ? "none" : "flex",
                      alignItems: "center",
                      width: "50%",
                    }}
                  >
                    <>
                      <Grid sx={{ display: "block" }} container>
                        <img
                          style={{ width: "100%" }}
                          src={doctor}
                          alt="doctor-lady"
                          className="doctor-image"
                        />
                        <Grid>
                          <Typography
                            variant="h1LatoBlack"
                            component={"div"}
                            sx={{
                              fontSize: "20px",
                              // lineHeight: matchesWidth ? "0px" : "55px",
                              color: "#093d4c",
                              letterSpacing: "2.08px",
                              lineHeight: "2.1rem",
                              textAlign: "center",
                            }}
                          >
                            “Finally, one savings tool that can help all my
                            patient save on their rising out-of-pocket Rx cost.
                            ”
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  </Box>
                </>
              )}
              {isShowBackgroundAssets && (
                <Box
                  sx={{
                    marginTop: "5rem",
                    display: {
                      xl: "block",
                      lg: "block",
                      md: "none",
                      sm: "none",
                      xs: "none",
                    },
                  }}
                >
                  <img
                    src={woman}
                    alt="top"
                    style={{ width: "44%", marginLeft: "35%" }}
                  />
                </Box>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ marginTop: "2rem" }}>
        <SubFooterView />
        <FooterView />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

export default connect(mapStateToProps)(SearchMainTemplate);